import NodeWrapper from './NodeWrapper';
import ContactStep from './ContactStep';
import ContactTopic from './ContactTopic';

export default class BaseItem extends NodeWrapper {
	private _parentTopicName! : string;
	private _step! : ContactStep;

	constructor($ctx : JQuery) {
		super($ctx);
		this.parentTopicName = this.$ctx.data('parentTopic');
	}

	get parentTopicName() {
		return this._parentTopicName;
	}

	set parentTopicName(topicName : string) {
		this._parentTopicName = topicName;
	}

	set step(step : ContactStep) {
		this._step = step;
		let pStep = this.step.getPreviousStep;
		if (pStep) {
			let parent = pStep.namedTopic(this.parentTopicName) as ContactTopic;
			if (parent) {
				this.setParent(parent);
			} else {
				pStep = this.step.getPreviousStep.getPreviousStep;
				if (pStep) {
					parent = pStep.namedTopic(this.parentTopicName) as ContactTopic;
					if (parent && parent.isResult) {
						this.setParent(parent);
					}
				}
			}
		}
	}

	get step() {
		return this._step;
	}

	public setParent(parent : NodeWrapper) {
		this.parent = parent;
		this.parent.addChild(this);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/BaseItem.ts